import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { CheckCircle, XCircle, Loader } from 'lucide-react';
import axios from 'axios';
import Navbar from '../components/Navbar';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading'); // loading | success | error
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      setMessage('Lien de vérification invalide ou manquant.');
      return;
    }

    const verify = async () => {
      try {
        const res = await axios.get(`${API_URL}/api/auth/verify-email?token=${token}`);
        setStatus('success');
        setMessage(res.data.message || 'Adresse email vérifiée avec succès !');
      } catch (error) {
        setStatus('error');
        setMessage(error.response?.data?.detail || 'Lien invalide ou déjà utilisé.');
      }
    };

    verify();
  }, [searchParams]);

  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <Navbar />
      <div className="max-w-md mx-auto px-4 py-20 text-center">
        <div className="bg-white rounded-2xl border border-[#E2E8F0] p-10 shadow-sm">

          {status === 'loading' && (
            <>
              <Loader className="w-16 h-16 text-[#0596DE] mx-auto mb-4 animate-spin" />
              <h2 className="text-xl font-bold text-[#0F172A]">Vérification en cours...</h2>
              <p className="text-[#64748B] mt-2">Veuillez patienter.</p>
            </>
          )}

          {status === 'success' && (
            <>
              <CheckCircle className="w-16 h-16 text-[#10B981] mx-auto mb-4" />
              <h2 className="text-xl font-bold text-[#0F172A] mb-2">Email vérifié ! ✅</h2>
              <p className="text-[#64748B] mb-6">{message}</p>
              <button
                onClick={() => navigate('/login')}
                className="w-full rounded-xl bg-[#0596DE] hover:bg-[#047CBA] h-12 text-base font-semibold text-white transition-colors"
              >
                Se connecter
              </button>
            </>
          )}

          {status === 'error' && (
            <>
              <XCircle className="w-16 h-16 text-[#EF4444] mx-auto mb-4" />
              <h2 className="text-xl font-bold text-[#0F172A] mb-2">Lien invalide</h2>
              <p className="text-[#64748B] mb-6">{message}</p>
              <button
                onClick={() => navigate('/register')}
                className="w-full rounded-xl bg-[#0596DE] hover:bg-[#047CBA] h-12 text-base font-semibold text-white transition-colors"
              >
                S'inscrire à nouveau
              </button>
            </>
          )}

        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;